(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-victor"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.getElementById('team-victor-{{ section.id }}');
  if (!section) return;

  const track = section.querySelector('.team-victor__track');
  const prevBtn = section.querySelector('.team-victor__arrow--prev');
  const nextBtn = section.querySelector('.team-victor__arrow--next');

  if (!track || !prevBtn || !nextBtn) return;

  const STEP = 3; // cards to scroll per click
  let current = 0;

  function cardWidth() {
    const card = track.querySelector('.team-victor__card');
    if (!card) return 212;
    const gap = 12;
    return card.offsetWidth + gap;
  }

  function totalCards() {
    return track.querySelectorAll('.team-victor__card').length;
  }

  function visibleCount() {
    const wrapper = section.querySelector('.team-victor__track-wrapper');
    if (!wrapper) return 3;
    return Math.floor(wrapper.offsetWidth / cardWidth());
  }

  function maxIndex() {
    return Math.max(0, totalCards() - visibleCount());
  }

  function update() {
    track.style.transform = `translateX(-${current * cardWidth()}px)`;
    prevBtn.disabled = current <= 0;
    nextBtn.disabled = current >= maxIndex();
  }

  prevBtn.addEventListener('click', function () {
    current = Math.max(0, current - STEP);
    update();
  });

  nextBtn.addEventListener('click', function () {
    current = Math.min(maxIndex(), current + STEP);
    update();
  });

  update();

  // Re-init on resize
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      current = Math.min(current, maxIndex());
      update();
    }, 150);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
